// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"3e9ccf93","704":"5a596d36","745":"7782054c"}[chunkId] + ".chunk.js";
};